import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Button from '@/components/ui/Button'
import { registerByInviteCode } from '@/services/clients'

export default function JoinTrainerPage() {
  const navigate = useNavigate()
  const [inviteCode, setInviteCode] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [success, setSuccess] = useState<{
    trainerName: string
    status: string
  } | null>(null)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()

    const code = inviteCode.trim().toUpperCase()
    if (!code) {
      setError('Введите код приглашения')
      return
    }

    setIsLoading(true)
    setError(null)

    try {
      const result = await registerByInviteCode(code)

      if (result.status === 'pending') {
        setSuccess({
          trainerName: result.trainer?.first_name || 'Тренер',
          status: 'pending'
        })
      } else if (result.status === 'approved' || result.status === 'trial') {
        // Уже подключен - перенаправляем на главную
        navigate('/')
      } else {
        // Уже есть связь
        setError(result.message || 'Вы уже связаны с этим тренером')
      }
    } catch (err: any) {
      const message = err.response?.data?.detail || 'Неверный код приглашения'
      setError(message)
    } finally {
      setIsLoading(false)
    }
  }

  if (success) {
    return (
      <div className="p-4">
        <div className="text-center py-12">
          <div className="text-6xl mb-4">✅</div>
          <h1 className="text-2xl font-bold text-tg-text mb-2">
            Заявка отправлена!
          </h1>
          <p className="text-tg-hint mb-6">
            Тренер {success.trainerName} получит уведомление о вашей заявке.
            <br />
            Ожидайте подтверждения.
          </p>
          <Button onClick={() => navigate('/')} variant="outline">
            На главную
          </Button>
        </div>
      </div>
    )
  }

  return (
    <div className="p-4">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-tg-text">
          Присоединиться к тренеру
        </h1>
        <p className="text-tg-hint mt-1">
          Введите код приглашения от вашего тренера
        </p>
      </div>

      <form onSubmit={handleSubmit}>
        {error && (
          <div className="bg-red-500/10 border border-red-500/20 text-red-500 p-3 rounded-lg mb-4 text-sm">
            {error}
          </div>
        )}

        <div className="mb-6">
          <label className="block text-sm font-medium text-tg-text mb-2">
            Код приглашения
          </label>
          <input
            type="text"
            value={inviteCode}
            onChange={(e) => setInviteCode(e.target.value.toUpperCase())}
            placeholder="XXXXXXXX"
            className="w-full p-4 bg-tg-secondary rounded-xl text-tg-text placeholder-tg-hint text-center text-xl font-mono tracking-widest focus:outline-none focus:ring-2 focus:ring-tg-button"
            autoComplete="off"
            autoCapitalize="characters"
          />
          <p className="text-xs text-tg-hint mt-2 text-center">
            Код состоит из букв и цифр
          </p>
        </div>

        <Button
          type="submit"
          fullWidth
          size="lg"
          loading={isLoading}
          disabled={!inviteCode.trim()}
        >
          Отправить заявку
        </Button>
      </form>

      <div className="mt-8 text-center">
        <p className="text-sm text-tg-hint">
          Нет кода? Попросите вашего тренера отправить вам ссылку-приглашение
        </p>
      </div>
    </div>
  )
}
